import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

// Angular Material
import { MatCardModule }         from '@angular/material/card';
import { MatButtonModule }       from '@angular/material/button';
import { MatIconModule }         from '@angular/material/icon';
import { MatInputModule }        from '@angular/material/input';
import { MatFormFieldModule }    from '@angular/material/form-field';
import { MatTooltipModule }      from '@angular/material/tooltip';
import { MatBadgeModule }        from '@angular/material/badge';
import { MatProgressBarModule }  from '@angular/material/progress-bar';
import { MatChipsModule }        from '@angular/material/chips';
import { MatDividerModule }      from '@angular/material/divider';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { DragDropModule }        from '@angular/cdk/drag-drop';

// Components
import { CopilotPanelComponent } from './copilot-panel/copilot-panel.component';
import { UsageProgressBarComponent } from './components/usage-progress-bar/usage-progress-bar.component';

// Pipes
import { CopilotToolLabelPipe } from './pipes/copilot-tool-label.pipe';
import { CopilotMarkdownPipe }  from './pipes/copilot-markdown.pipe';

// Services (provided in root — no need to list here)

@NgModule({
  declarations: [
    CopilotPanelComponent,
    UsageProgressBarComponent,
    CopilotToolLabelPipe,
    CopilotMarkdownPipe,
  ],
  imports: [
    CommonModule,
    FormsModule,
    MatCardModule,
    MatButtonModule,
    MatIconModule,
    MatInputModule,
    MatFormFieldModule,
    MatTooltipModule,
    MatBadgeModule,
    MatProgressBarModule,
    MatChipsModule,
    MatDividerModule,
    MatButtonToggleModule,
    DragDropModule,
  ],
  exports: [
    CopilotPanelComponent,
    UsageProgressBarComponent,
    CopilotToolLabelPipe,
    CopilotMarkdownPipe,
  ],
})
export class CopilotModule {}
